module.exports = __webpack_public_path__ + "media/images/line_contact-2839adcc7fa5f4f115e30cbe7cc6ddf8.png";